export const opsConstants = {
    AIRTABLE_RECONCILIATION_REPORT_REQUEST: "AIRTABLE_RECONCILIATION_REPORT_REQUEST",
    AIRTABLE_RECONCILIATION_REPORT_SUCCESS: "AIRTABLE_RECONCILIATION_REPORT_SUCCESS",
    AIRTABLE_RECONCILIATION_REPORT_FAILURE: "AIRTABLE_RECONCILIATION_REPORT_FAILURE",

  };